import React, { useEffect, useState, useSyncExternalStore } from "react";
import { getCausedCalls, subscribeLoading } from "../utils/request";
import classes from "./header.module.scss";

// a quick call never flashes the line, and a short gap between two calls doesn't blink it
const SHOW_AFTER_MS = 300;
const HIDE_AFTER_MS = 200;

/** The thin gold line under the header while CRX works on something the person asked for. */
const LoadingLine: React.FC = () => {
    const isBusy = useSyncExternalStore(subscribeLoading, getCausedCalls) > 0;
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        const timer = window.setTimeout(() => setIsShown(isBusy), isBusy ? SHOW_AFTER_MS : HIDE_AFTER_MS);
        return () => window.clearTimeout(timer);
    }, [isBusy]);

    return isShown ? <div className={classes.loadingLine} data-testid="loading-line" aria-hidden="true" /> : null;
};

export default LoadingLine;
